import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/site";

export const Testimonials = () => {
  return (
    <section id="reviews" className="bg-[var(--apex-primary)] relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-[0.04]" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-28">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--apex-accent)]">Reviews</p>
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl text-white mt-3">
            What Lehigh Valley homeowners say
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.blockquote
              key={t.name}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 2) * 0.1 }}
              className="relative rounded-md bg-white/5 backdrop-blur border border-white/10 p-7"
            >
              <Quote size={32} className="text-[var(--apex-accent)] mb-3" />
              <p className="text-slate-100 leading-relaxed">"{t.text}"</p>
              <div className="mt-5 flex items-center justify-between">
                <div>
                  <div className="font-display font-bold text-white">{t.name}</div>
                  <div className="text-sm text-slate-400">{t.city}</div>
                </div>
                <div className="flex text-[var(--apex-accent)]">
                  {[...Array(t.stars)].map((_, s) => <Star key={s} size={16} fill="currentColor" />)}
                </div>
              </div>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
